import { Routes } from '@angular/router';
import { BettingOnlyGuard } from 'src/guards/betting-only/betting-only.guard';
import { MobileScreenGuard } from 'src/guards/screen-size/mobile.guard';

export const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.routes').then(m => m.HOME_ROUTES)
  },
  {
    path: 'promotions',
    loadChildren: () => import('./pages/promotions/promotions.routes').then(m => m.PROMOTIONS_ROUTES),
    canActivate: [BettingOnlyGuard]
  },
  {
    path: 'support',
    loadChildren: () => import('./pages/support-pages/support.routes').then(m => m.SUPPORT_ROUTES)
  },
  {
    path: 'bet',
    loadChildren: () => import('./pages/bet/bet-selection.routes').then(m => m.BET_SELECTION_ROUTES)
  },
  {
    path: 'ticket',
    loadChildren: () => import('./pages/ticket/ticket.routes').then(m => m.TICKET_ROUTES)
  },
  {
    path: 'turf',
    loadChildren: () => import('./pages/turf-pages/turf.routes').then(m => m.TURF_ROUTES)
  },
  {
    path: 'user',
    loadChildren: () => import('./pages/auth/auth.routes').then(m => m.AUTH_ROUTES),
    canActivate: [BettingOnlyGuard]
  },
  {
    path: 'profile',
    loadChildren: () => import('./pages/profile-pages/profile.routes').then(m => m.PROFILE_ROUTES),
    canActivate: [BettingOnlyGuard]
  },
  {
    path: 'reunion',
    loadChildren: () => import('./pages/reunion/reunion.routes').then(m => m.REUNION_ROUTES),
    canActivate: [MobileScreenGuard]
  },
  {
    path: 'cagnotte',
    loadChildren: () => import('./components/nav/cagnotte.routes').then(m => m.CAGNOTTE_ROUTES),
    canActivate: [MobileScreenGuard]
  },
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: '**', redirectTo: 'home', pathMatch: 'full' }
];
